'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface ViewerRoleContextValue {
  isPartner: boolean;
}

const ViewerRoleContext = createContext<ViewerRoleContextValue>({
  isPartner: false,
});

export function ViewerRoleProvider({
  isPartner,
  children,
}: {
  isPartner: boolean;
  children: ReactNode;
}) {
  return (
    <ViewerRoleContext value={{ isPartner }}>{children}</ViewerRoleContext>
  );
}

export function useViewerRole() {
  return useContext(ViewerRoleContext);
}
